import { Component, Input, OnInit } from '@angular/core';
import { MasterDataService } from '../masterdata/masterdata.service';
import { LabMDM } from '../masterdata/models/lab';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';
import { SelectableLab } from '../carrier/selectable-lab';
import { WorkFlow } from '../masterdata/models/workFlow';
import * as cloneDeep from 'lodash/cloneDeep';
import * as omit from 'lodash/omit';
import { BBResponseContainer } from '../carrier/response-container';
import { SelectItem } from 'primeng/api';
import { Controls } from '../masterdata/models/controls';

@Component({
  selector: 'app-work-flow',
  templateUrl: './work-flow.component.html',
  styleUrls: ['./work-flow.component.css']
})
export class WorkFlowComponent implements OnInit {

  @Input() masterLists: Array<WorkFlow>;

  _labOptions: Array<LabMDM>;

  @Input() tableCols: Array<WorkFlow>;

  @Input() title: string;

  @Input() set labOptions(input: LabMDM[]) {
    this._labOptions = input.filter((lab: LabMDM) => lab.name === this.checkSelectedLab.lab.name);
  }

  @Input() checkSelectedLab: SelectableLab;

  errorHandler: ErrorHandler = new ErrorHandler();

  workFlowGroupsOptions: Array<any>;

  productOptions: Array<any>;

  processScaleOptions: Array<any>;

  controlSchemaOptions: SelectItem[] = [];

  selectedWorkFlow: any;

  workFlow: WorkFlow;

  showWorkFlowDialouge: boolean;

  selectableLab: SelectableLab;

  selectedLabId: string;

  selectedWorkFlowGroup: any;

  controls: Controls[] = [];

  constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService) {
    this.showErrorOnSave = this.showErrorOnSave.bind(this);
    this.showErrorOnUpdate = this.showErrorOnUpdate.bind(this);
  }

  ngOnInit() {
    this.masterLists = [];
    this.selectableLab = JSON.parse(localStorage.getItem('lab'));
    this.selectedLabId = this.selectableLab.lab._id;

    this.workFlowGroupsOptions = [
      { name: 'STR-SNP', value: 'STR-SNP' }
    ];
    this.productOptions = [
      {label: 'SNP', value: 'SNP'},
      {label: 'STR', value: 'STR'},
      {label: 'TEST', value: 'TEST'},
      {label: 'STR-P', value: 'STR-P'}

    ]
    this.selectedWorkFlowGroup = null;

  }

  handleAddNewWorkFlow() {
    this.workFlow = { product: [], extractionOnly: false, active: false };
    this.selectedWorkFlowGroup = null;
    this.showWorkFlowDialouge = true;
    this.controlSchemaOptions = [];
    this.getControls();
  }

  handleSaveOrUpdate() {
    const { _id } = this.workFlow;
    if (this.isValid()) {
      this.workFlow.displayName = this.workFlow.workFlowName;
      this.workFlow.workFlowGroup = this.selectedWorkFlowGroup.value;
      if (_id) {
        this._masterDataService.updateWorkFlow(JSON.stringify(this.workFlow), this.selectedLabId, _id).subscribe((response) => {
          this.showWorkFlowDialouge = false;
          const selectedWorkFlowIndex: number = this.masterLists.findIndex((workFlowData: WorkFlow) => workFlowData._id === _id);
          this.masterLists[selectedWorkFlowIndex] = response;
        }, this.showErrorOnUpdate);
      } else {
        this._masterDataService.createWorkFlow(JSON.stringify(this.workFlow), this.selectedLabId, "workflow").subscribe((response: BBResponseContainer) => {
          const { data } = response;
          this.masterLists.push(data);
          this.showWorkFlowDialouge = false;
        }, this.showErrorOnSave);
      }
    }
  }

  showErrorOnSave() {
    this._messageService.addErrorMessage({
      severity: 'error', summary: 'Error',
      detail: "Failed to create work flow. Try with other work flow name, may be it is duplicate"
    });
  }
  
  showErrorOnUpdate() {
    this._messageService.addErrorMessage({
      severity: 'error', summary: 'Error',
      detail: "Failed to update work flow configurations.Try with other work flow name, may be it is duplicate"
    });
  }
  
  isValid() {
    const { workFlowName = '', lab , product, controlSchema} = this.workFlow;
    this.workFlow = omit(this.workFlow, ['nameError', 'locationError', 'labError', 'handlerError']);
    if (!workFlowName.trim().length) {
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'WorkFlow name',
        detail: 'Work flow name cannot be empty'
      });
      (this.workFlow as any).nameError = true;
      return false;
    } else if (!lab) {
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'Lab',
        detail: 'Please select the Lab'
      });
      (this.workFlow as any).labError = true;
      return false;
    } else if (!this.selectedWorkFlowGroup) {
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'WorkFlow Group',
        detail: 'Work flow group cannot be empty'
      });
      (this.workFlow as any).nameError = true;
      return false;
    } else if (!product || product.length<1){
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'Empty Products',
        detail: 'Atleast one product must be selected'
      })
      return false;
    } else if (!controlSchema || controlSchema==='') {
      this._messageService.addErrorMessage({
        severity: 'error', summary: 'Control Schema',
        detail: 'Control Schema cannot be empty'
      });
      (this.workFlow as any).nameError = true;
      return false;
    }
    return true;
  }

  handleRowSelect(event: any) {
    const { data } = event;
    const { lab = {} } = data;
    const { _id = '' } = lab;
    this.workFlow = cloneDeep(data);
    this.workFlow.lab = this._labOptions.find((labOption: LabMDM) => labOption._id === _id);
    this.controlSchemaOptions=[];
    this._masterDataService.getActiveControls(this.selectedLabId, "controls").subscribe(
      results => {
        if (!results) {
          return;
        }
        this.controls = results.data;
        this.controls.forEach(control => {
          if(control.controlConfigurationName!=this.workFlow.controlSchema){
          this.controlSchemaOptions.push({ label: control.controlConfigurationName, value: control.controlConfigurationName });
          }
        });
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
    this.controlSchemaOptions.push({ label: this.workFlow.controlSchema, value: this.workFlow.controlSchema });
    this.showWorkFlowDialouge = true;
  }

  private getControls() {
    this.controlSchemaOptions=[];
    this._masterDataService.getActiveControls(this.selectedLabId, "controls").subscribe(
      results => {
        if (!results) {
          return;
        }
        this.controls = results.data;
        this.controls.forEach(control => {
          this.controlSchemaOptions.push({ label: control.controlConfigurationName, value: control.controlConfigurationName });
        });
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
      }
    );
  }

}
